import { Component } from '@angular/core';
import {
  BRONZE_CONTRIBUTORS,
  DIAMOND_CONTRIBUTORS,
  GOLD_CONTRIBUTORS,
  PLATINUM_CONTRIBUTORS,
  SILVER_CONTRIBUTORS
} from 'src/app/data/contributor/contributor.data';
import { EMPLOYEES } from 'src/app/data/employee/employee.data';
import { OTH_TIME_LINE } from 'src/app/data/timeline/timeline.data';
import { environmentCommon } from '../../../../environments/environment-common';

@Component({
  selector: 'app-about-us-page',
  templateUrl: './about-us-page.component.html',
  styleUrls: ['./about-us-page.component.scss'],
})
export class AboutUsPageComponent {
  OTH_TIME_LINE = OTH_TIME_LINE;
  EMPLOYEES = EMPLOYEES;
  DIAMOND_CONTRIBUTORS = DIAMOND_CONTRIBUTORS;
  PLATINUM_CONTRIBUTORS = PLATINUM_CONTRIBUTORS;
  GOLD_CONTRIBUTORS = GOLD_CONTRIBUTORS;
  SILVER_CONTRIBUTORS = SILVER_CONTRIBUTORS;
  BRONZE_CONTRIBUTORS = BRONZE_CONTRIBUTORS;

  websites = [];

  employeeAppHeroContents = [
    {
      text: $localize`:@@aboutUs.employeeAppHero.text:About Us`,
      level: 1,
    },
    {
      text: "SR Group is a pioneer in the sales and service of specialised industrial products. Additionally, we offer solution-based products to the metal cutting and fabrication industries, including Aerospace, Space, Defence, Mould & dies, automobile manufacturers, and workshops. We also provide products to process industries, such as cement and pharmaceutical and chemical industries among others. We have established ourselves as a respected name in the industry through our unwavering commitment to professionalism, customer-centric service, and dedication for over three decades"
    },
    {
      text: "Our reputation is built upon a foundation of dependability, expertise, and a vast network of channel partners and associates. We provide a variety of high-quality products and services, including speciality welding alloys and machines, automobile maintenance solutions, rust preventives, speciality lubricants, and carbide cutting tools. We are honoured to serve as a comprehensive solution provider for your industrial requirements"
    },
  ];
  journeyContents = [
    {
      text: 'Our Journey',
      level: 2,
    },
    {
      text: "At SR Group, we are driven by a vision of a brighter future and are dedicated to surpassing customer expectations through the pursuit of efficiency and excellence. Our goal is to provide our customers with the most advanced products and services at the most cost-effective price, thereby enabling them to confront future challenges as genuine partners in progress",
    },
    {
      text: "Established in October 1992, SR Engineers was founded in a modest facility by two individuals who shared a common vision. In 1994, Alcade Engineers Pvt. Ltd. was founded with the objective of enhancing and expanding the industrial solutions portfolio that had already been established."
    },
    {
      text: "Consequently, we established branch offices to more effectively and efficiently meet the industry's needs, thereby broadening and optimising our operations. In 2006, SR Logistics India Pvt. Ltd. was established in one of the major industrial areas of Hyderabad to further enhance their industrial solutions and services. The company boasts a state-of-the-art warehouse that ensures efficient inventory management and logistics support"
    },
    {
      text: "At SR Group, we are dedicated to the pursuit of quality, integrity, and innovation. We remain committed to the establishment of enduring relationships with our clients, suppliers, and industry partners, as well as the development of innovative solutions. We maintain our position at the forefront of industry advancements and market demands by consistently evolving, which is underpinned by a customer-centric approach and a robust technical foundation."
    }
  ];

  followUsAppHeroContents = [
    {
      text: "Partner with SR Group – Where Innovation Meets Industrial Excellence!",
      level: 2,
    },
    {
      text: '',
    },
  ];

  contactInformationAppHeroContents = [
    {
      text: $localize`:@@aboutUs.contactInfoAppHero.contactInfoText:Contact Information`,
      level: 2,
    },
  ];

  constructor(
  ) {

    for (const website in environmentCommon.company.social) {
      if (environmentCommon.company.social[website] && website === 'linkedin') {
        this.websites.push({
          name: environmentCommon.website[website].name,
          handle: environmentCommon.company.social[website],
          cssClass: environmentCommon.website[website].cssClass,
          url: this.getUrl(website),
        });
      }
    }
  }

  ngOnInit() { }

  redirect(href: string) {
    window.location.href = href;
  }

  private getUrl(website: string) {
    let url = environmentCommon.website[website].url;

    if (environmentCommon.website[website].companyUrl) {
      url = environmentCommon.website[website].companyUrl;
    } else if (environmentCommon.website[website].channelUrl) {
      url = environmentCommon.website[website].channelUrl;
    }

    return url;
  }
}
